<template>
  <div
    v-if="$store.state.permissions.mainPage"
    class="flex flex-row h-screen"
  ></div>
</template>

<script>
export default {};
</script>

<style></style>
